import {DsrList} from "./DsrList";
import {DsrEdit} from "./DsrEdit";
import {DsrCreate} from "./DsrCreate";

export default {
    list: DsrList,
    create: DsrCreate,
    edit: DsrEdit
};
